<script setup>
import AutomationKanbanMoveInput from './AutomationKanbanMoveInput.vue';

const props = defineProps({
  modelValue: {
    type: [Array, Object],
    default: () => [],
  },
});

const emit = defineEmits(['update:modelValue', 'input']);
</script>

<template>
  <AutomationKanbanMoveInput
    mode="stage"
    :model-value="props.modelValue"
    @update:model-value="emit('update:modelValue', $event)"
    @input="emit('input', $event)"
  />
</template>
